import React from "react";
import { useContent } from "../contexts/ContentContext";
import ConsultCTA from "./ConsultCTA";

export default function About() {
  const { firm } = useContent();
  const ABOUT = firm.about;
  return (
    <section id="about" className="py-28 bg-[#fbf9f6] paper-bg">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-5">
            <span className="text-xs uppercase tracking-[0.3em] text-[#b8924a] font-medium">Our Firm</span>
            <h2 className="font-serif text-5xl md:text-6xl text-[#1a2c4e] mt-4 leading-tight">
              {ABOUT.heading}
            </h2>
            <div className="gold-divider-left" />
            <p className="text-[#4a6d8c] italic font-serif text-xl mt-4">
              Idaho-rooted counsel since the firm&rsquo;s founding traditions began over four decades ago.
            </p>
          </div>

          <div className="lg:col-span-7 space-y-6">
            {ABOUT.body.map((p) => (
              <p key={p.slice(0, 40)} className="text-[#3a4d6b] text-lg leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-3 gap-px bg-stone-200 border border-stone-200">
          {ABOUT.stats.map((s) => (
            <div key={s.label} className="bg-[#fbf9f6] py-10 px-4 text-center">
              <div className="font-serif text-5xl text-[#1a2c4e] font-light">{s.value}</div>
              <div className="text-xs uppercase tracking-widest text-[#4a6d8c] mt-2">{s.label}</div>
            </div>
          ))}
        </div>

        <ConsultCTA source="Home page — About section" body="Have a question or need counsel? We're here to listen." />
      </div>
    </section>
  );
}
